/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
import React, { Fragment } from 'react'
import { defineMessages, useIntl } from 'react-intl'

import { timeFormatter } from '@elastic/charts'
import { EuiFlexGroup, EuiFlexItem, EuiIcon, EuiSpacer, EuiText } from '@elastic/eui'

const messages = defineMessages({
  disclaimer: {
    id: `project.charts.disclaimer`,
    defaultMessage: `This bucket may contain partial data.`,
  },
})

export const TooltipHeader = ({
  value,
  max,
  format,
}: {
  value: number
  max: number
  format: string
}) => {
  const { formatMessage } = useIntl()
  const formattedValue = timeFormatter(format)(value)

  if (value === max) {
    return (
      <Fragment>
        <EuiFlexGroup alignItems='center' responsive={false} gutterSize='xs'>
          <EuiFlexItem grow={false}>
            <EuiIcon type='info' />
          </EuiFlexItem>
          <EuiFlexItem>
            <EuiText size='xs'>{formatMessage(messages.disclaimer)}</EuiText>
          </EuiFlexItem>
        </EuiFlexGroup>
        <EuiSpacer size='xs' />
        {formattedValue}
      </Fragment>
    )
  }

  return <Fragment>{formattedValue}</Fragment>
}
